<div class="desktop-menu">
  <div class="menu-container">
    <div class="container">
      <div class="logo">
        <a class="link" href="#" (click)="returnToDashboard($event)">
          <img src="../../../../assets/img/Logo.png" alt="Asseta logo">
        </a>
      </div>
    </div>
    <debtor-panel-greeting [userName]="this.store.userName()"/>
    <div class="buttons-container">
      @if (this.store.userName() !== null && this.store.userName() !== undefined) {
        <button mat-flat-button class="white-left-button btn-border" (click)="showData()">{{ 'menu.buttons.show-data' | translate }}</button>
      }
      <div class="text-action">
        <button
          mat-icon-button
          (click)="DecreaseFontSize()"
          [attr.aria-label]="'alt-for-img.decrease-text' | translate ">
          <mat-icon  class="decrease"  svgIcon="font_decrease_icon"></mat-icon>
        </button>
        <button
          mat-icon-button
          (click)="IncreaseFontSize()"
          [attr.aria-label]="'alt-for-img.increase-text' | translate ">
          <mat-icon  class="custom-icon"  svgIcon="font_increase_icon"></mat-icon>
        </button>
      </div>
      <button mat-flat-button class="change-password-btn btn-border" (click)="changePassword()">{{ 'menu.buttons.change-password' | translate }}<mat-icon class="icon">settings</mat-icon></button>
      <button mat-flat-button class="logout btn-common" (click)="logout($event)">{{ 'menu.buttons.logout' | translate }} <mat-icon class="icon">power_settings_new</mat-icon></button>
    </div>
  </div>
</div>
<div class="menu-mobile">
  <mat-toolbar class="nav-mobile">
    <div class="header-container">
      <a class="link" href="#" (click)="returnToDashboard($event)">
        <img src="../../../../assets/img/Logo.png" alt="Asseta logo" class="mobile-logo" >
      </a>

      <div class="empty-space"></div>
                  <div class="text-action">
              <button
                mat-icon-button
                (click)="DecreaseFontSize()"
                [attr.aria-label]="'alt-for-img.decrease-text' | translate ">
                <mat-icon  class="decrease"  svgIcon="font_decrease_icon"></mat-icon>
              </button>
              <button
                mat-icon-button
                (click)="IncreaseFontSize()"
                [attr.aria-label]="'alt-for-img.increase-text' | translate ">
                <mat-icon  class="custom-icon"  svgIcon="font_increase_icon"></mat-icon>
              </button>
            </div>
      <button class="close-button" mat-icon-button (click)="toggleMenu()">
        @if (!isMobileMenuOpen) {
          <mat-icon >menu</mat-icon>
        } @else {
          <mat-icon  class="custom-icon"  svgIcon="close_custom_icon"></mat-icon>
        }
      </button>
    </div>
  </mat-toolbar>
  <div class="mobile-menu-content" [class.open]="isMobileMenuOpen">
    <mat-nav-list>
      <a mat-list-item routerLink="/" routerLinkActive="active-list-item" [routerLinkActiveOptions]="{exact:true}">{{ 'menu.menu-mobile.return-to-dashboard' | translate }}</a>
      @if (this.store.userName() !== null && this.store.userName() !== undefined) {
        <a mat-list-item routerLink="user-details" routerLinkActive="active-list-item"  [routerLinkActiveOptions]="{exact:true}">{{ 'menu.menu-mobile.show-data' | translate }}</a>
      }
      <a mat-list-item >{{ 'menu.buttons.change-password' | translate }}</a>
      <a mat-list-item href="#" (click)="logout($event)">{{ 'menu.buttons.logout' | translate }}</a>
    </mat-nav-list>
  </div>
</div>
